(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7366],{

/***/ 21851:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course-center",
      function () {
        return __webpack_require__(38802);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ CourseCenterPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pages_course_center_container_CourseCenterContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23523);
/* harmony import */ var _components_CourseCenterRoot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16851);




var __N_SSP = true;
function CourseCenterPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_course_center_container_CourseCenterContext__WEBPACK_IMPORTED_MODULE_2__/* .ProvideCourseCenterContext */ .H, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CourseCenterRoot__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,5002,5397,6851,2888,179], function() { return __webpack_exec__(21851); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);